import React from 'react'

function Rep_AccountsReports() {
  return (
    <div>"Accounts Reports (revenue, pending bills)</div>
  )
}

export default Rep_AccountsReports